const totesCountQuery = `
  {
    tote_count
  }  
`

const currentTotesQuery = `
  query WebCurrentTotes($page: Int, $filter: TotesFilter) {
    totes (page: $page, per_page: 5, filter: $filter) 
    {
        id
        stock_locked_at
        locked_at
        other_product_feedback
        state
        swapped
        fc_address
        scheduled_self_shunfeng_tips
        scheduled_self_description
        tote_shipping_address {
          address_1
          city
          country
          district
          full_name
          state
          telephone
        }
        eligiable_operation_plans {
          id
          new_banner_url
          new_banner_width
          landing_page_url
        }
        progress_status {
          delivered_at
          description
          locked_at
          schedule_returned_at
          shipped_at
          status
          title
          hide_delivered_btn
        }
        pull_tote_tip
        hive_box_scheduled_pickup {
          id
          admin_user_id
          latest_return_at
          status
          tracking_number
        }
        return_shipping_vendor
        scheduled_return {
          allowed_commands
          return_shipping_vendor
          scheduled_tote_free_purchase_return {
            id
            slot_count
          }
          scheduled_auto_pickup {
            address_1
            city
            district
            full_name
            id
            processing_status
            requested_pickup_at
            shipping_code
            state
            telephone
            order_state_code
            order_state_desc
            express_service_telephone
          }
          scheduled_self_delivery {
            id
            shipping_code
            latest_return_at
          }
          tote {
            id
            return_shipping_vendor
          }
          tote_free_service {
            id
            exempt_rent_tote_free_service_banners {
              id
              title
              image_url
              link
            }
            exempt_rent_scheduled_return_banners {
              id
              title
              image_url
              link
            }
            return_slot_count
            hint {
              schedule_page_keep
              schedule_page_return
              state
              tote_page_return_remind {
                message
                type
              }
            }
            purchase_slots
            state
          }
          tote_free_purchase {
            id
            state
            return_slot_count
            hint {
              state
              tote_page_return_remind {
                type
                message
              }
            }
          }
          scheduled_tote_free_purchase_return {
            id
            scheduled_tote_free_purchase_return_items {
              id
              reason
              tote_product {
                id
                transition_state
                product {
                  catalogue_photos {
                    medium_url
                  }
                }
              }
            }
            slot_count
          }
        }
        tote_free_service {
          id
          return_slot_count
          free_service_type {
            id
            name
            clothing_count
          }
          exempt_rent_tote_free_service_banners {
            id
            title
            image_url
            link
          }
          exempt_rent_scheduled_return_banners {
            id
            title
            image_url
            link
          }
          hint {
            schedule_page_keep
            schedule_page_return
            state
            tote_page_return_remind {
              message
              type
            }
          }
          state
          purchase_slots
          scheduled_return {
            allowed_commands
            return_shipping_vendor
            scheduled_auto_pickup {
              address_1
              city
              district
              full_name
              id
              processing_status
              requested_pickup_at
              shipping_code
              state
              telephone
              order_state_code
              order_state_desc
              express_service_telephone
            }
            scheduled_self_delivery {
              id
              shipping_code
              latest_return_at
            }
            tote {
              id
              return_shipping_vendor
            }
            tote_free_service {
              id
            }
            scheduled_tote_free_purchase_return {
              id
              scheduled_tote_free_purchase_return_items {
                id
                reason
                tote_product {
                  id
                  transition_state
                  product {
                    catalogue_photos {
                      medium_url
                    }
                  }
                }
              }
              slot_count
            }
          }
        }
        tote_free_purchase {
          id
          state
          return_slot_count
          hint {
            state
            tote_page_return_remind {
              type
              message
            }
          }
          scheduled_return {
            allowed_commands
            return_shipping_vendor
            scheduled_auto_pickup {
              address_1
              city
              district
              full_name
              id
              processing_status
              requested_pickup_at
              shipping_code
              state
              telephone
              order_state_code
              order_state_desc
              express_service_telephone
            }
            scheduled_self_delivery {
              id
              shipping_code
              latest_return_at
            }
            tote {
              id
              return_shipping_vendor
            }
            tote_free_purchase {
              id
            }
            scheduled_tote_free_purchase_return {
              id
              scheduled_tote_free_purchase_return_items {
                id
                reason
                tote_product {
                  id
                  transition_state
                  product {
                    catalogue_photos {
                      medium_url
                    }
                  }
                }
              }
              slot_count
            }
          }
        }
        outbound_shipping_code
        delivered_at
        scheduled_at
        rental
        rateable
        rating_incentive {
          has_incentived
          has_incentived_amount
          image_url
          link
        }
        product_parts {
          parts {
            photoUrl
            title
          }
          product_title
        }
        customer_nth_tote
        orders {
          id
          line_items {
            __typename
            ... on ProductLineItem {
              amount
              product {
                id
              }
            }
          }
          summary {
            total_amount
            purchase_credit
            discount
            promo_code_discount
            tiered_percent_discount {
              display_name
              discount_amount
            }
          }
          operation_plans {
            label_text
            display_title
          }
        }
        tote_products {
          charge_scope
          overdue_total_amount
          order {
            id
            title
            operation_plans {
              label_text
              display_title
            }
            summary {
              total_amount
              purchase_credit
              discount
              promo_code_discount
              tiered_percent_discount {
                display_name
                discount_amount
              }
            }
            paid_at
            payment {
              gateway
            }
            line_items
            {
              ... on ProductLineItem
              {
                amount
                tote_product {
                  id
                  charge_scope
                }
                product {
                  charge_scope
                  parts{
                    title
                  }
                  full_price
                  brand {
                    name
                  }
                  title
                  member_price
                  full_price
                  catalogue_photos {
                    thumb_url
                    medium_url
                  }
                }
                size {
                  name
                }
              }
            }
          }
          tote_specific_price
          product_item {
            state
          }
          transition_info {
            modified_price
          }
          transition_state
          customer_photos {
            id
            mobile_url
            url
            thumb_url
            customer_city
            customer_height_inches
            customer_name
            customer_nickname
            product_size
          }
          id
          product_size {
            id
            bust_max_tolerance
            bust_min_tolerance
            hips_max_tolerance
            hips_min_tolerance
            waist_max_tolerance
            waist_min_tolerance
            size_abbreviation
            size {
              id
              name
            }
            swappable
          }
          rating {
            id
          }
          service_feedback {
            quality_issues_human_names
            quality_photo_urls
          }
          product {
            full_price
            activated_at
            id
            type
            tote_slot
            disabled
            charge_scope
            category_rule {
              error_msg
              hint_msg
              slug
              swap_ban_threshold
              swap_hint_threshold
            }
            category {
              name
              accessory
            }
            brand {
              name
            }
            parts{
              title
            }
            title
            swappable
            member_price
            full_price
            catalogue_photos {
              thumb_url
              medium_url
            }
          }
        }
        shipping_status {
          title
          message
          steps {
            styling {
              header
              complete
            }
            styled {
              header
              complete
            }
            preparing {
              header
              complete
            }
            in_transit {
              header
              complete
            }
            delivered {
              header
              complete
            }
          }
        }
        tote_rating {
          rating
        }
        skip_perfect_closet
        perfect_closets {
          id
          product {
            id
          }
          tote {
            id
            return_shipping_vendor
          }
          tote_product {
            id
          }
        }
        display_rate_incentive_guide
    }
  }
`

const historyTotesQuery = `
  query WebHistoryTotes(
    $page: Int
    $per_page: Int
    $filter: TotesFilter
  ) {
    totes(
      page: $page
      per_page: $per_page
      filter: $filter
    ) {
      id
      state
      delivered_at
      locked_at
      display_rate_incentive_guide
      return_shipping_vendor
      rating_incentive {
        has_incentived_amount
      }
      tote_rating {
        id
        rating
        max_rating
      }
      return_shipping_summary {
        shipping_code
        placeholder
      }
      tote_products {
        id
        order {
          id
          paid_at
          operation_plans {
            label_text
            display_title
          }
          summary {
            total_amount
            purchase_credit
            discount
            promo_code_discount
            tiered_percent_discount {
              display_name
              discount_amount
            }
          }
          line_items
          {
            ... on ProductLineItem
            {
              amount
              tote_product {
                id
                charge_scope
              }
              product {
                charge_scope
                parts{
                  title
                }
                full_price
                brand {
                  name
                }
                title
                member_price
                full_price
                catalogue_photos {
                  thumb_url
                  medium_url
                }
              }
              size {
                name
              }
            }
          }
        }
        product_item {
          state
        }
        transition_info {
          modified_price
        }
        transition_state
        product_size {
          id
          size_abbreviation
          size {
            id
            name
            abbreviation
          }
          swappable
        }
        rating {
          id
        }
        product {
          disabled
          closet_count
          charge_scope
          category {
            id
            name
            accessory
            clothing
          }
          categories {
            id
            name
          }
          category_rule {
            slug
          }
          brand {
            id
            name
          }
          catalogue_photos {
            medium_url
            giant_url
          }
          id
          full_price
          title
          type
          member_price
          tote_slot
        }
      }
    }
  }
`

const deliveredTotesQuery = `
  query WebDeliveredTotes(
    $page: Int
    $per_page: Int
    $filter: TotesFilter
  ) {
    totes (page: $page, per_page: $per_page, filter: $filter)
    {
      id
      tote_products {
        id
        customer_photos {
          id
          mobile_url
        }
        product_size {
          id
          size_abbreviation
          size {
            id
            name
          }
        }
        product {
          id
          title
          disabled
          charge_scope
          brand {
            id
            name
          }
          category {
            id
            accessory
          }
          catalogue_photos {
            medium_url
            full_url
          }
        }
      }
    }
  }
`

const toteStateTipsQuery = `
  query WebToteStateTips {
    tote_state_tips {
      credit_account_validation {
        errors {
          error_code
          message
        }
        success
      }
      transaction_validation {
        errors {
          error_code
          message
        }
        success
      }
      subscription_validation {
        errors {
          error_code
          message
        }
        success
      }
      extra_validation {
        errors {
          error_code
          message
        }
        success
      }
      tote_return_validation {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
`

export default {
  totesCountQuery,
  currentTotesQuery,
  historyTotesQuery,
  deliveredTotesQuery,
  toteStateTipsQuery
}
